<template>
	<div>
		<b-card no-body class="mh-card mh-card-TimeClock-wrap">
			<b-card-header class="mh-bg-primary d-flex align-items-center">
				<h3 class="card-title">Time Clock</h3>
			</b-card-header>
			<b-card-body>
				<b-row cols="1" cols-md="2" no-gutters>
					<b-col md="auto">
						<div class="mh-profile-label">
							<div class="mh-img-wrap">
								<ProfileImage :imageUrl="profilePicture" />
								<span class="mh-user-online"></span>
							</div>
							<span class="mh-title">{{profile.email}}</span>
						</div>
					</b-col>
					<b-col md="4">
						<div v-if="isClockedIn" class="mh-time-wrap text-right">
							<small>Clocked In At</small>
							<h5>{{currentClockInTime}}</h5>
						</div>
					</b-col>
				</b-row>
				<b-row no-gutters>
					<b-col cols="12">
						<b-card no-body class="mh-card card-outline mh-card-Totals">
							<b-card-header>
								<h3 class="card-title">Totals</h3>
							</b-card-header>
							<b-card-body>
								<b-row class="text-center justify-content-md-center" no-gutters>
									<b-col lg="3" md="12">
										<div class="mh-time-box">
											<span class="mh-label">CURRENT</span>
											<span class="mh-time" v-html="totalsCurrent"></span>
										</div>
									</b-col>
									<b-col lg="3" md="12">
										<div class="mh-time-box">
											<span class="mh-label">DAY</span>
											<span class="mh-time">{{totalsToday}}</span>
										</div>
									</b-col>
									<b-col lg="3" md="12">
										<div class="mh-time-box">
											<span class="mh-label">WEEK</span>
											<span class="mh-time">{{totalsWeek}}</span>
										</div>
									</b-col>
									<b-col lg="3" md="12">
										<div class="mh-time-box">
											<span class="mh-label">FORTNIGHT</span>
											<span class="mh-time">{{totalsFortnight}}</span>
										</div>
									</b-col>
								</b-row>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
				<b-row no-gutters>
					<b-col cols="12">
						<b-card v-if="!isClockedIn" no-body class="mh-card card-outline mh-card-Customers">
							<b-card-header>
								<h3 class="card-title">Customers</h3>
							</b-card-header>
							<b-card-body>
								<h5 class="mh-section-title-wrap">TOP</h5>
								<b-nav v-if="topCustomers.length > 0" vertical>
									<b-nav-item v-for="(topCustomer, index) in topCustomers" :key="index">
										<div class="mh-title"><i class="mh-icon-star"></i> {{topCustomer.customer}}</div>
										<div class="mh-time ml-auto">{{topCustomer.completedHours}}</div>
									</b-nav-item>
								</b-nav>
								<b-nav v-else vertical>
									<b-nav-item>
										There are no customers to display
									</b-nav-item>
								</b-nav>
							</b-card-body>
						</b-card>
						<b-card v-else no-body class="mh-card card-outline mh-card-Customers">
							<b-card-header>
								<h3 class="card-title">Customer</h3>
							</b-card-header>
							<b-card-body>
								<h5 class="mh-section-title-wrap">CURRENT</h5>
								<b-nav vertical>
									<b-nav-item>
										<div class="mh-title"><i class="mh-icon-star"></i> {{currentTimeClockShift.clientfullname}}</div>
										<div class="mh-time ml-auto" v-html="totalsCurrent"></div>
									</b-nav-item>
								</b-nav>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
				<b-row v-if="isClockedIn" no-gutters>
					<b-col cols="12">
						<div class="form-group">
							<label class="mh-label required">Notes</label>
							<textarea v-model="notes" class="form-control" placeholder="Write Your Note Here..." @change="saveShiftNotes"></textarea>
						</div>
					</b-col>
				</b-row>
				<b-row class="mh-footer-action-btns" no-gutters>
					<b-col lg="6" md="12">
						&nbsp;
					</b-col>
					<b-col lg="6" md="12" class="text-right">
						<button v-if="!isClockingIn && !isClockedIn" @click="showClockInForm" class="btn btn-success btn-lg mh-btn btn-block">Clock In</button>
						<ClockOutForm v-if="isClockedIn" @save-form="saveClockOutForm" :notes="notes" :currentTimeClockShift="currentTimeClockShift" />
					</b-col>
				</b-row>
			</b-card-body>
		</b-card>

		<b-modal :visible="isClockingIn" @hide="hideClockInForm" modal-class="shift-summary" body-class="mh-off-middle" size="lg" hide-footer>
			<template slot="modal-title">
				<h5 class="modal-title">Clock In</h5>
			</template>
			<template slot="default">
				<ClockInForm @close-form="hideClockInForm" @save-form="saveClockInForm" />
			</template>
		</b-modal>
	</div>
</template>

<script>
	import ClockInForm from './ClockInForm'
	import ClockOutForm from './ClockOutForm'
	import ProfileImage from './ProfileImage'
	import moment from "moment"

	export default {
		name: 'TimeClock',
		components: {
			ClockInForm,
			ClockOutForm,
			ProfileImage
		},
		props: {
			records: Array
		},
		data: function () {
			return {
				notes: null,
				clockingIn: false,
				now: new Date()
			}
		},
		mounted: function () {
			this.$store.dispatch("Intervals/set", { name: "TimeClockNow", callback: () => { this.now = new Date() }, timeout: 500 })
		},
		destroyed: function () {
			this.$store.commit("Intervals/clear", "TimeClockNow")
		},
		watch: {
			currentTimeClockShift: {
				immediate: true,
				handler(newValue, oldValue) {
					if (this.currentTimeClockShift != null)
						this.notes = this.currentTimeClockShift.shiftnotes
				}
			}
		},
		computed: {
			profile: function () {
				return this.$store.state.Profile.profile
			},
			customers: function () {
				return this.$store.state.Customers.customers
			},
			timeClockShifts: function () {
				return this.records
			},
			profilePicture: function () {
				return this.profile.profilepic
			},
			isClockingIn: function () {
				return this.clockingIn
			},
			isClockedIn: function () {
				return this.currentTimeClockShift != null
			},
			currentTimeClockShift: function () {
				return this.$store.getters["Shifts/currentTimeClockShift"]
			},
			currentClockInTime: function () {
				var clockInTime = ""

				if (this.currentTimeClockShift != null && this.currentTimeClockShift.clockintime != null && this.currentTimeClockShift.clockintime != "")
					clockInTime = moment(this.currentTimeClockShift.clockintime, "DD/MM/YYYY h:mm:ss A").format("hh : mm A")

				return clockInTime
			},
			totalsCurrent: function () {
				var current = "00 : 00 : <small>00</small>"

				if (this.isClockedIn) {
					var difference = moment(this.now).diff(moment(this.currentTimeClockShift.clockintime, "DD/MM/YYYY h:mm:ss A"))

					current = moment.duration(difference).format("hh : mm : [<small>]ss[</small>]", { forceLength: true, trim: false })
				}

				return current
			},
			totalsToday: function () {
				var today = "00 : 00"
				var todaysTimeClockShifts = this.timeClockShifts
						.filter(x => moment(x.servicedate, "DD/MM/YYYY h:mm:ss A").format("DD/MM/YYYY") == moment().format("DD/MM/YYYY"))

				if (todaysTimeClockShifts != null && todaysTimeClockShifts.length > 0) {
					var completedHours = todaysTimeClockShifts.map(x => parseFloat("0" + x.timesheettotalhours)).reduce(function (a, b) {
						return a + b
					}, 0)

					today = moment.duration(completedHours, 'hours').format('hh : mm', { forceLength: true, trim: false})
				}

				return today
			},
			totalsWeek: function () {
				var week = "00 : 00"
				var weekTimeClockShifts = this.timeClockShifts
					.filter(x => moment(x.servicedate, "DD/MM/YYYY h:mm:ss A").isBetween(moment().startOf("isoWeek"), moment().endOf("isoWeek")))

				if (weekTimeClockShifts != null && weekTimeClockShifts.length > 0) {
					var completedHours = weekTimeClockShifts.map(x => parseFloat("0" + x.timesheettotalhours)).reduce(function (a, b) {
						return a + b
					}, 0)

					week = moment.duration(completedHours, 'hours').format('HH : mm', { forceLength: true, trim: false })
				}

				return week
			},
			totalsFortnight: function () {
				var fortnight = "00 : 00"

				if (this.timeClockShifts != null && this.timeClockShifts.length > 0) {
					var completedHours = this.timeClockShifts.map(x => parseFloat("0" + x.timesheettotalhours)).reduce(function (a, b) {
						return a + b
					}, 0)

					fortnight = moment.duration(completedHours, 'hours').format('HH : mm', { forceLength: true, trim: false })
				}

				return fortnight
			},
			topCustomers: function () {
				var customers = []
				
				if (this.timeClockShifts != null && this.timeClockShifts.length > 0) {
					this.timeClockShifts.forEach(function (o) {
						var filteredCustomers = customers.filter(x => x.customer == o.clientfullname)

						if (filteredCustomers.length < 1) {
							customers.push({ customer: o.clientfullname, completedHours: parseFloat("0" + o.timesheettotalhours) })
						} else {
							filteredCustomers[0].completedHours += parseFloat("0" + o.timesheettotalhours)
						}
					})

					customers = customers.sort(this.$store.getters["Helper/compareValues"]("completedHours", "desc"))
					customers = customers.slice(0, 3)

					customers.forEach(function (o) {
						if (o.completedHours == 0) {
							o.completedHours = "00 : 00"
						}
						else {
							o.completedHours = moment.duration(o.completedHours, 'hours').format('HH : mm', { forceLength: true, trim: false })
						}
					})
				}
				
				return customers
			},
			isNotesValid: function () {
				if (this.notes == null || this.notes == "") {
					this.$store.commit("Toasts/showError", { title: "Notes", content: "Notes are required!" })

					return false
				}

				 return true
			}
		},
		methods: {
			showClockInForm: function () {
				this.clockingIn = true
			},
			hideClockInForm: function () {
				this.clockingIn = false
			},
			saveClockInForm: function () {
				this.clockingIn = false
				
				this.$emit("save-clockin-form")
			},
			saveClockOutForm: function () {
				this.clockingIn = false
				this.notes = null
				
				this.$emit("save-clockout-form")
			},
			saveShiftNotes: function () {
				if (!this.isNotesValid) {
					return
				}

				var parameters = {
					serviceScheduleId: this.currentTimeClockShift.servicescheduleid,
					notes: this.notes
				}

				this.$store.dispatch("Shifts/saveShiftNotes", parameters)
			}
		}
	}
</script>

<style scoped>
	.iconContainer {
		white-space: nowrap;
	}

	.card.mh-card .card-header {
		padding: 20px 25px 20px;
	}
</style>